import React, { createContext, FC, useState } from "react";

interface AuthContextProps {
  auth: any;
  setAuth: (value: any) => void;
  persist: boolean;
  setPersist: (persist: boolean) => void;
}
const AuthContext = createContext<AuthContextProps>({} as AuthContextProps);
export const AuthProvider: FC<{children: React.ReactNode}> = ({ children }) => {
  const [auth, setAuth] = useState<any>({});
  const [persist, setPersist] = useState<boolean>(false);

  return (
    <AuthContext.Provider value={{ auth, setAuth, persist, setPersist }}>
      {children}
    </AuthContext.Provider>
  );
};
export default AuthContext;